/**
 * Pulls the error messages out of a failed API call's HttpErrorResponse.
 *
 * Handles both 400 shapes the server returns: `ApiBadRequest` sends `{ errors: string[] }`, while
 * ASP.NET's automatic model validation sends `{ errors: { [field]: string[] } }`.
 */
export function apiErrorMessages(response: any): string[] {
  const errors = response?.error?.errors;
  if (Array.isArray(errors)) {
    return errors.map(String);
  }
  if (errors && typeof errors === 'object') {
    return Object.values(errors).flatMap((v) => (Array.isArray(v) ? v.map(String) : [String(v)]));
  }
  if (typeof response?.error === 'string' && response.error) {
    return [response.error];
  }
  return response?.message ? [response.message] : [];
}
